import { render, staticRenderFns } from "./ChoosePostTypeController.vue?vue&type=template&id=6d5f8647&"
import script from "./ChoosePostTypeController.vue?vue&type=script&lang=ts&"
export * from "./ChoosePostTypeController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports